import React from "react";

import IconButton from "@material-ui/core/IconButton";
import InsertPhotoIcon from "@material-ui/icons/InsertPhoto";
import PlayIcon from "@material-ui/icons/PlayCircleOutline";
import { useTextToSpeech } from "./texttospeech/useTextToSpeech";

import { SlideAction } from "./SlideAction";
import { useOfflineStatus } from "../../../utilities/useOfflineStatus";
import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles(() => ({
	mobileSlidePrompt: {
		position: "absolute",
		zIndex: 9999,
	},
	mobileSlidePromptButton: {
		border: "1px solid",
		padding: 4,
		display: "block",
	},
	mobileTextToSpeechButton: {
		border: "1px solid",
		padding: 4,
		marginTop: 5,
		display: "block",
		"&:disabled": {
			color: "white",
		},
	},
}));

export type MobileFormatBubbleSettings = { right: number; top: number; action: SlideAction };

interface Props {
	settings: MobileFormatBubbleSettings;
	onClickSlidePrompt: (slideAction: SlideAction) => void;
}

export function MobileFormatBubble(props: Props) {
	const mobileSlidePrompt = props.settings;
	const classes = useStyles();
	const { startTextToSpeech } = useTextToSpeech();
	const isOnline = !useOfflineStatus();

	return (
		<div
			className={classes.mobileSlidePrompt}
			style={{
				right: mobileSlidePrompt.right,
				top: mobileSlidePrompt.top,
			}}
		>
			<IconButton className={classes.mobileSlidePromptButton} onClick={() => props.onClickSlidePrompt(mobileSlidePrompt.action)}>
				<InsertPhotoIcon />
			</IconButton>
			{isOnline && (
				<IconButton className={classes.mobileTextToSpeechButton} onClick={() => startTextToSpeech()}>
					<PlayIcon />
				</IconButton>
			)}
		</div>
	);
}